
<div>
  <altcha-widget
      ref="altchaWidget"
      :auto="auto"
      :strings="strings"
      challengeurl="/api/altcha"
      floating="auto"
      hidefooter
      hidelogo
      name="a_c"
  ></altcha-widget>
</div>
